import React from 'react';
import ExchangeReason from './ExchangeReason';

export const ExchangeItem = ({
  availableAmount,
  selected,
  exchangeReason,
  originalOrderEntry: { baseImage, size, name, description, link, color, entryNumber },
  setFormValues,
}) => {
  return (
    <div className="product-row">
      <div className="product-info">
        <a href={link}>
          <img src={baseImage} alt={name} />
        </a>
        <div className="product-details">
          <h3 className="product-details__name">
            {name.toUpperCase()} {description}
          </h3>
          <p>Colour: {color}</p>
          <p>Size: {size}</p>
          <p className="product-details__amount">{availableAmount}</p>
        </div>
      </div>
      <ExchangeReason {...{ entryNumber, setFormValues, availableAmount, selected, exchangeReason }} />
    </div>
  );
};
